import React, { useState, useMemo, useCallback, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Container } from "reactstrap";
import ContactLoader from "views/ContantLoader";
import { postSaveAudienceData } from "api/AudienceApi";
import { postFiltersPersonsCount, postFiltersPersons , putSaveAudienceData} from "api/AudienceApi";
import Table from "../Table";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setAudienceLoading } from "ReduxStore/Slices/audienceSlice";
import { getAudieceFilteredData } from "helperFuntion/getAudienceFilter";
const PreviewAudience = (props) => {
  // const config = JSON.parse(sessionStorage.getItem("KW_saveAudience_data"));
  const [dataApi, setDataApi] = useState([]);
  const [audienceCount, setAudienceCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const dispatch = useDispatch();
  const {
    audienceLoading,
    audienceFilters,
    audienceName,
    audienceDescription,
    editingAudience,
  } = useSelector((state) => state.audienceSetter);
  var audienceData = {
    name: audienceName,
    description: audienceDescription,
    type: "Dynamic",
    filters: getAudieceFilteredData(audienceFilters),
  };

  useEffect(() => {
    dispatch(setAudienceLoading(true));
  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setAudienceLoading(true));
    const startRow = pageSize * pageIndex;
    setPageIndex(pageIndex);

    await postFiltersPersonsCount(audienceData)
      .then((data) => {
        setAudienceCount(data.count);
        setPageCount(Math.ceil(data.count / pageSize));
      })
      .catch((e) => {
        toast.error(e.message);
      });

    await postFiltersPersons(audienceData, startRow, pageSize)
      .then((data) => {
        setDataApi(data);
        dispatch(setAudienceLoading(false));
      })
      .catch((e) => {
        toast.error(e.message);
        dispatch(setAudienceLoading(false));
      });
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
    ],
    []
  );
  const data = useMemo(() => dataApi, [dataApi]);

  const saveAudience = (e) => {

    e.preventDefault();

    var audienceData = {
      name: audienceName,
      description: audienceDescription,
      type: "Dynamic",
      filters: getAudieceFilteredData(audienceFilters),
    };

    console.log(editingAudience)
    if (editingAudience){
      putSaveAudienceData(audienceData, editingAudience)
        .then((data) => {
          toast.success("Audience has been Saved successfully.");
          sessionStorage.removeItem("KW_Previous_AUD");
          props.history.push({
            pathname: "/admin/contact/audience/details",
          });
        })
        .catch((e) => { });


    }
    else{
      //save audience api call and then clearing sessionStorage item to reset the form
      postSaveAudienceData(audienceData)
        .then((data) => {
          toast.success("Audience saved successfully");
          props.history.push({
            pathname: "/admin/contact/audience/details",
          });
        })
        .catch(function (error) {

        });
    }

  };
  return (
    <Container>
      <div className="page_heading">
        <button
          className="btn btn-sm"
          style={{ color: "#114169" }}
          onClick={() => {
            props.history.push(`/admin/contact/audience/create`);
          }}
        >{`< Back`}</button>
        <h2>Audience List</h2>

        <p className="sm d-flex align-items-center">
          You have {audienceCount} Contact's in this Audience
        </p>
      </div>
      <div></div>
      {
        <div className="dataTableOuter">
          <div className="table-flter rdt_Pagination d-flex align-items-center">
            <span className="inline-label ml-auto">
              Page No. {pageIndex + 1} of {pageCount}
            </span>
          </div>
          {
            <Table
              columns={columns}
              data={data}
              fetchData={fetchData}
              pageCount={pageCount}
              loading={audienceLoading}
            ></Table>
          }
        </div>
      }
      <a
       id='saveAudience'
        onClick={(e) => saveAudience(e)}
        style={{ margin: "1vh", cursor: "pointer", maxWidth: "140px", padding:"7px", position:"absolute", left:"60px", bottom:"0" }}
        className="lg_btn tertiary"
        value=""
      >
        Save Audience
      </a>
    </Container>
  );
};

export default PreviewAudience;
